import React from "react";
import Form from "../Components/Form";
import "../ComponentsCSS/BookNow.css"
import { Link } from "react-router-dom";
import SEO from "./SEO";

const BookNow = () => {
  return (
    <>
      <SEO
        title="Book a Shuttle | SASK A One Shuttle | Prince Albert"
        description="Book your next ride with SASK A One Shuttle online. Fast, friendly, and reliable ground transportation across Saskatchewan."
        keywords="book shuttle Prince Albert, online shuttle booking Saskatchewan, Sask A One Shuttle booking"
      />
      <div className="container-fluid my-5 py-5 text-center book-page" data-aos="slide-up">
        <h1 data-aos="zoom-in">Book Now</h1>
        <p data-aos="zoom-in">Home / BookNow</p>
      </div>
      <Form />
       <hr />
      {/* Location  */}
      <div className="location py-5 my-5 px-4" data-aos="zoom-in">
        <div className="container-fluid">
          <div className="row">
            <div className="location-content col-md-6 col-lg-4 col-sm-12 mb-5">
              <h1>Visit Us</h1>

              <h2 className="mt-3">Hours</h2>
              <p className="mt-3">Monday - Sunday</p>
              <p className="mt-3">12:00AM - 12:00PM</p>

              <h2>Contacts</h2>
              <Link className="text-decoration-none text-black mt-3" to="">
                +1 (639) 470-2917
              </Link>
              <Link className="text-decoration-none text-black mt-3" to="">
                +1 (306) 491-6375
              </Link>
              <Link className="text-decoration-none text-black mt-3" to="">
                admin@saskaoneshuttle.com
              </Link>
              <Link className="text-decoration-none text-black mt-3" to="">
                #2-75 South Industrial Drive,
Prince Albert, SK. S6V 7L7, Ca
              </Link>
            </div>

            {/* Map */}
            <div className="col-md-6 col-sm-12 col-lg-8 map">
              <iframe
                src="https://maps.google.com/maps?q=75%20South%20Industrial%20Drive,%20Prince%20Albert,%20SK%20S6V%207L7&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="900"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="ACE Shuttle Location Map"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookNow;
